module.exports = __webpack_public_path__ + "img/blob-p.8bb6a42b.svg";